import { render, staticRenderFns } from "./GithubLogo.vue?vue&type=template&id=5afbb9e4"
var script = {}
import style0 from "./GithubLogo.vue?vue&type=style&index=0&id=5afbb9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports